module.exports = __webpack_public_path__ + "img/portrait-102.411ffcf1.jpg";